import { Text } from '@loomhq/lens';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { endVideoSettingsFlow, startVideoSettingsFlow } from 'actions/editor';
import { HELP_TRIM_VIDEO } from 'constants/feature-tour';

import AddVideoCtaButton from 'components/share-video/add-video-cta-button';
import CTAForm from 'components/share-video/cta-form';
import CustomThumbnailButton from 'components/share-video/custom-thumbnail-button';
import ThumbnailWidget from 'components/share-video/thumbnail-widget';
import TrimModeButton from 'components/share-video/trim-mode-button';
import VideoSettings from 'components/share-video/video-settings';
import ActionDot, { TOP_LEFT } from 'components/ui-components/action-dot';
import FabButton from 'components/ui-components/fab-button';
import Tooltip from 'components/ui-components/tooltip';

import './styles.less';

const EDITOR_MODE_CLASS = 'editor-mode-enabled';

class EditorWidget extends Component {
  render() {
    const {
      ctaFlow,
      thumbnailFlow,
      privacySettingsFlow,
      customAccessFlow,
      videoSettingsFlow,
      video,
      hasCustomThumbnail,
      hasCta,
      onEnterTrimMode,
      inUploadMode,
      settingPassTrimTourActive,
    } = this.props;

    const editorActive =
      ctaFlow ||
      thumbnailFlow ||
      customAccessFlow ||
      privacySettingsFlow ||
      videoSettingsFlow;
    const className =
      (ctaFlow ? ' cta' : '') +
      (customAccessFlow ? ' custom-access' : '') +
      (privacySettingsFlow ? ' privacy' : '') +
      (thumbnailFlow ? ' thumbnail' : '') +
      (videoSettingsFlow ? ' video-settings' : '');

    const itemArray = [
      !editorActive && (
        <Fragment key="edit-video">
          <div className="edit-video-header">
            <Text variant="title">Edit Your Video</Text>
            <div className="edit-video-header-status">
              {hasCustomThumbnail && (
                <div className="edit-video-header-thumbnail">
                  <Tooltip>Video has a custom thumbnail</Tooltip>
                </div>
              )}
              {hasCta && (
                <div className="edit-video-header-cta">
                  <Tooltip>Video has call-to-action link</Tooltip>
                </div>
              )}
            </div>
          </div>
          <div className="edit-video-buttons">
            {settingPassTrimTourActive && <ActionDot position={TOP_LEFT} />}
            <FabButton
              onClick={this.props.startVideoSettingsFlow}
              icon="settings-rp"
            >
              Settings
            </FabButton>
            <TrimModeButton onClick={onEnterTrimMode} disabled={inUploadMode} />
            <AddVideoCtaButton
              disabled={inUploadMode}
              showUpgradeModal={this.props.showUpgradeModal}
            />
            <CustomThumbnailButton
              disabled={inUploadMode}
              showUpgradeModal={this.props.showUpgradeModal}
            />
          </div>
        </Fragment>
      ),
      ctaFlow && <CTAForm key="cta-form" />,
      thumbnailFlow && <ThumbnailWidget key="thumbnail-widget" />,
      videoSettingsFlow && (
        <VideoSettings
          key="video-settings"
          video={video}
          onSaveClick={this.props.endVideoSettingsFlow}
          onCancelClick={this.props.endVideoSettingsFlow}
        />
      ),
    ].filter(Boolean);

    return (
      <div className={`edit-video${className}`}>
        {itemArray.map(item => (
          <div key={item.key}>{item}</div>
        ))}
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.editorMode != prevProps.editorMode) {
      const rootElement = document.documentElement;

      rootElement.className = rootElement.className.replace(
        EDITOR_MODE_CLASS,
        ''
      );

      if (this.props.editorMode) {
        rootElement.className += ` ${EDITOR_MODE_CLASS}`;
      }
    }
  }
}

const mapStateToProps = state => {
  const {
    editor,
    user: { current: user },
    share_video: {
      cta_enabled: hasCta,
      video: { thumbnails = {} },
    },
    video_player: { in_upload_mode: inUploadMode },
  } = state;
  const {
    cta_flow: ctaFlow,
    thumbnail_flow: thumbnailFlow,
    privacy_settings_flow: privacySettingsFlow,
    video_settings_flow: videoSettingsFlow,
    custom_access_flow: customAccessFlow,
    editorMode = ctaFlow || thumbnailFlow,
  } = editor;

  const { currentTour, tourOpenAndActive } = state.featureTour;

  const settingPassTrimTourActive =
    currentTour === HELP_TRIM_VIDEO && tourOpenAndActive;

  const capabilities = user && user.capabilities;

  return {
    ctaFlow,
    thumbnailFlow,
    privacySettingsFlow,
    customAccessFlow,
    videoSettingsFlow,
    editorMode,
    hasCta,
    inUploadMode,
    hasCustomThumbnail: thumbnails.full,
    settingPassTrimTourActive,
    userCapabilities: capabilities || {},
  };
};

const mapDispatchToProps = dispatch => ({
  startVideoSettingsFlow: () => dispatch(startVideoSettingsFlow()),
  endVideoSettingsFlow: () => dispatch(endVideoSettingsFlow()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditorWidget);
